var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-table',{ref:"table",attrs:{"api-builder":_vm.apiBuilder,"columns":_vm.columns,"row-actions":_vm.rowActions,"bulk-actions":[],"search-fields":null,"on-delete-item":_vm.onDeleteItem},scopedSlots:_vm._u([{key:"direction",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("general." + (item.direction))))+" ")]}},{key:"is_main",fn:function(ref){
var item = ref.item;
return [_c('i',{class:{ 'text-success icon-checkmark': item.is_main }})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }